module.exports = __webpack_public_path__ + "img/lottery_background.04a71fbc.jpg";